import { Booth } from 'models/cms/booths';

const pickFieldFromCMSBoothTargetBooth = <K extends keyof Booth>(booth: Booth, field: K, locales: string[]) => {
  switch (field) {
    case 'name':
      return locales
        .map((it) => booth?.name?.[it])
        .filter((it) => it)
        ?.[0] || '';
    case 'description': {
      const description = locales
        .map((it) => booth?.description?.[it])
        .filter((it) => it)
        ?.[0] || '';
      const content = new DOMParser().parseFromString(description, 'text/html')?.body?.textContent?.trim();
      if (!content) return '';
      return description;
    }
    case 'descriptionBanner': return null;
    default: return booth[field];
  }
};

export default pickFieldFromCMSBoothTargetBooth;
